import IdPhotoDefault from '../../assets/image/id-photo-default.png'
export const TeacherDetail = {
  data () {
    return {
      IdPhotoDefault: IdPhotoDefault,
      loading: true,
      userInfo: {},
      sourceBaseUrl: '',
      schoolId: 0,
      profession_id: 0,
      professionList: [],
      currentIndex: 0
    }
  },
  mounted () {
    if (this.$route.query.school_id != undefined) {
      this.schoolId = this.$route.query.school_id;
    }
    if (this.$route.query.profession_id != undefined) {
      this.profession_id = this.$route.query.profession_id;
    }
    console.log(this.$route);
    this.sourceBaseUrl = this.$root.sourceBaseUrl;
    this.getUserInfo();
    this.getProfessionType();
  },
  methods: {
    switchProfession (index) {
      // console.log(index);
      this.currentIndex = index;
      this.profession_id = this.professionList[index].id;
      this.$router.push('/main/teachersteams?school_id=' + this.schoolId + '&profession_id=' + this.profession_id);
    },
    getUserInfo () {
      this.loading = true;
      this.$http.get(this.$root.apiBaseUrl + '?g=api&m=api2&a=get_teacher_info&teacher_id=' + this.$route.params.id).then(function (response) {
        if (response.body.status == 1) {
          this.userInfo = response.body.data;
        }
        this.loading = false;
      }, function (reserror) {
        console.log(reserror);
      })
    },
    // 获取专业分类
    getProfessionType () {
      var that = this;
      this.$http.get(this.$root.apiBaseUrl + '?g=api&m=api2&a=get_all_profession_list&school_id=' + this.schoolId).then(function (response) {
        if (response.body.status == 1) {
          if (response.body.data != null && response.body.data != '') {
            this.professionList = response.body.data;
            // this.professionList.unshift({ name: '全部', path: '/main/teachersteams' });
            this.professionList.forEach(function (item, index) {
              if (item.id == that.profession_id) {
                that.currentIndex = index;
              }
            })
          }
        }
      }, function (reserror) {
        console.log(reserror);
      })
    }
  }
}